import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/*
 * Route guards are UX-only. Authorization and data access are enforced by the API
 * (adminAuth middleware on protected endpoints). Never rely on these checks alone.
 */

/* ── Auth guard: redirect to /login if not authenticated ── */
export function ProtectedRoute({ children }) {
  const { isAuthenticated } = useSelector((s) => s.auth);
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

/* ── Admin guard: requires admin session; API remains source of truth ── */
export function AdminRoute({ children }) {
  const { isAuthenticated, user } = useSelector((s) => s.auth);
  const isAdmin = user?.role && user.role.toLowerCase() === 'admin';

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
}

/* ── Guest guard: redirect authenticated users away from auth pages ── */
export function GuestRoute({ children }) {
  const { isAuthenticated, user } = useSelector((s) => s.auth);

  if (!isAuthenticated) {
    return children;
  }

  const isAdmin = user?.role && user.role.toLowerCase() === 'admin';
  if (isAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Navigate to="/" replace />;
}
